/* CSTM GOAL QUIZ v11 — 8 vragen + puntensysteem + kritische drempels + cafeine-cap + beta alanine sensitivity-cap + tooltips + ingredient info */
(function () {
  'use strict';

  var STEPS = {
    'Caféïne':           [0, 0.1, 0.2, 0.3, 0.35, 0.4],
    'Tyrosine':          [0, 0.5, 1.0, 1.5, 2.0, 2.5],
    'Acetyl L-Carnitine':[0, 0.25, 0.5, 0.75, 1.0, 1.5, 2.0],
    'L-Citrulline':      [0, 2, 3, 4, 5, 6, 7, 8],
    'Glycerol':          [0, 1.5, 3.0],
    'Beta Alanine':      [0, 1, 2, 3.2, 4, 5],
    'L-Arginine':        [0, 1, 2, 3, 4],
    'Taurine':           [0, 0.5, 1.0, 1.5, 2.0, 2.5, 3.0],
    'Glycine':           [0, 0.5, 1, 1.5, 2, 3],
    'Elektrolyten':      [0, 1.0, 2.0],
    'Piperine':          [0, 0.005]
  };

  /* Korte "waarom zit dit erin" uitleg per ingrediënt, getoond op het resultaatscherm. */
  var INGREDIENT_INFO = {
    'Caféïne': 'Stimuleert je zenuwstelsel voor meer alertheid en fysieke prestaties.',
    'Tyrosine': 'Verbetert focus en helpt je stressbestendig blijven onder druk.',
    'Acetyl L-Carnitine': 'Ondersteunt energieproductie en hersenfunctie, vertraagt mentale vermoeidheid.',
    'L-Citrulline': 'Verbetert de doorbloeding voor een sterkere pomp en minder vermoeidheid.',
    'Glycerol': 'Houdt vocht vast in je spiercellen voor een vollere, langdurigere pomp.',
    'Beta Alanine': 'Buffert verzuring zodat je langer door kunt zetten.',
    'L-Arginine': 'Verwijdt bloedvaten voor extra doorbloeding en spiervulling.',
    'Taurine': 'Ondersteunt hydratatie, spiercontractie en uithoudingsvermogen.',
    'Glycine': 'Bevordert herstel en houdt je zenuwstelsel kalm onder belasting.',
    'Elektrolyten': 'Reguleren je vochtbalans en voorkomen kramp tijdens zware sessies.',
    'Piperine': 'Verhoogt de opname van de andere ingrediënten in je formule.'
  };

  function snapToStep(name, value) {
    var steps = STEPS[name];
    if (!steps) return value;
    var best = steps[0], bestDiff = Infinity;
    for (var i = 0; i < steps.length; i++) {
      var diff = Math.abs(steps[i] - value);
      if (diff < bestDiff) { bestDiff = diff; best = steps[i]; }
    }
    return best;
  }

  /* Beta Alanine algeheel plafond nu 3.2g — de wetenschappelijk onderbouwde
     enkelvoudige-serving dosis. Hogere builder-stappen (4g/5g) blijven
     beschikbaar in de handmatige builder maar worden via de quiz nooit bereikt. */
  var MAX = {
    'Caféïne': 0.4, 'Tyrosine': 2.5, 'Acetyl L-Carnitine': 2.0,
    'L-Citrulline': 8, 'Glycerol': 3.0, 'Beta Alanine': 3.2,
    'L-Arginine': 4, 'Taurine': 3.0, 'Glycine': 3,
    'Elektrolyten': 2.0, 'Piperine': 0.005
  };

  /* Minimale effectieve drempel per ingrediënt — kritisch herzien. */
  var MIN_EFFECTIVE = {
    'Caféïne':            0.1,
    'Tyrosine':           1.5,
    'Acetyl L-Carnitine':  1.0,
    'L-Citrulline':       3.0,
    'Glycerol':           1.5,
    'Beta Alanine':       2.0,
    'L-Arginine':         2.0,
    'Taurine':            1.5,
    'Glycine':            1.5,
    'Elektrolyten':       1.0
    /* Piperine heeft geen drempel — altijd 0.005g */
  };

  var CAFFEINE_MAP = { none: 0, low: 0.1, medium: 0.2, high: 0.3, expert: 0.4 };

  /* Cafeine-cap voor explosieve, coördinatie-afhankelijke sporten. */
  var CAFFEINE_CAP_TRAININGS = ['team', 'hyrox'];
  var CAFFEINE_CAP_VALUE = 0.2;

  /* Beta Alanine cap op basis van ervaring met het tintelende gevoel (paresthesie).
     Voorkomt dat klanten die hier niet van houden of het nooit hebben gevoeld
     direct een hoge, overweldigende dosis krijgen. */
  var BETA_ALANINE_SENSITIVITY_CAP = {
    loved:     3.2,   /* ervaren en vond het geweldig — volledige wetenschappelijke dosis */
    disliked:  1.6,   /* vindt dit niet fijn — halve dosis, geen merkbare tinteling */
    never:     2.0,   /* nooit geprobeerd — voorzichtige introductiedosis */
    unsure:    2.0    /* geen idee wat dit betekent — zelfde voorzichtige introductiedosis */
  };

  var INTENSITY_MULTIPLIER = { light: 0.75, moderate: 0.90, intense: 1.00, extreme: 1.15 };

  var BASE = {
    'L-Citrulline': 4, 'L-Arginine': 0, 'Glycerol': 0,
    'Beta Alanine': 1.6, 'Taurine': 1.5, 'Elektrolyten': 0,
    'Tyrosine': 1, 'Acetyl L-Carnitine': 0, 'Glycine': 0,
    'Piperine': 0.005
  };

  var POINTS = {
    goal: {
      energy:    { 'Tyrosine': 1, 'Acetyl L-Carnitine': 1, 'Glycine': 1 },
      pump:      { 'L-Citrulline': 3, 'L-Arginine': 2, 'Glycerol': 3 },
      endurance: { 'Beta Alanine': 1.6, 'Taurine': 0.5, 'Elektrolyten': 1, 'Glycine': 1 },
      allround:  { 'L-Citrulline': 1, 'Beta Alanine': 0.4, 'Tyrosine': 0.5, 'Taurine': 0.5, 'Glycine': 1 }
    },
    training: {
      strength:  { 'L-Citrulline': 1, 'L-Arginine': 1, 'Taurine': 0.5 },
      endurance: { 'Beta Alanine': 0.4, 'Elektrolyten': 1, 'Taurine': 0.5 },
      team:      { 'Tyrosine': 0.5, 'Taurine': 0.5, 'Beta Alanine': 0.4 },
      hyrox:     { 'Beta Alanine': 0.8, 'Elektrolyten': 1, 'L-Citrulline': 1, 'Taurine': 0.5 }
    },
    timing: {
      morning: { 'Elektrolyten': 0.5 },
      midday:  {},
      evening: {},
      varies:  {}
    },
    feeling: {
      energy:  { 'Tyrosine': 0.5, 'Acetyl L-Carnitine': 0.5 },
      muscles: { 'Beta Alanine': 0.8, 'Taurine': 0.5 },
      focus:   { 'Tyrosine': 0.5, 'Acetyl L-Carnitine': 1, 'Glycine': 0.5 },
      breath:  { 'L-Citrulline': 1, 'Elektrolyten': 0.5, 'Beta Alanine': 0.4 }
    }
  };

  var RESULT_NAMES = { energy: 'Energy Focus', pump: 'Maximum Pump', endurance: 'Endurance Boost', allround: 'All-Round Formule' };
  var RESULT_SUBS  = {
    energy:    'Maximale focus en drive — klaar om alles te geven.',
    pump:      'Extreme doorbloeding en spiervulling.',
    endurance: 'Langer presteren, minder vermoeidheid.',
    allround:  'Gebalanceerde formule voor iedere training.'
  };

  var answers = { goal: null, training: null, timing: null, caffeine: null, feeling: null, betaAlanine: null, intensity: null, smaak: null };
  var ANSWER_KEYS = ['goal', 'training', 'timing', 'caffeine', 'feeling', 'betaAlanine', 'intensity', 'smaak'];
  var TOTAL_STEPS = 8;
  var currentStep = 0;

  function getEffectiveCaffeine(training, caffeineChoice) {
    var requested = CAFFEINE_MAP[caffeineChoice] || 0;
    if (CAFFEINE_CAP_TRAININGS.indexOf(training) !== -1 && requested > CAFFEINE_CAP_VALUE) {
      return CAFFEINE_CAP_VALUE;
    }
    return requested;
  }

  function calculateFormula() {
    var goal        = answers.goal        || 'allround';
    var training    = answers.training    || 'strength';
    var timing      = answers.timing      || 'varies';
    var caffeine    = answers.caffeine    || 'medium';
    var feeling     = answers.feeling     || 'energy';
    var betaAlanine = answers.betaAlanine || 'never';
    var intensity   = answers.intensity   || 'intense';

    /* 1. Start met basis */
    var formula = {};
    Object.keys(BASE).forEach(function(k){ formula[k] = BASE[k]; });

    /* 2. Voeg punten toe per vraag */
    function addPoints(qKey, aVal) {
      var qp = POINTS[qKey];
      if (!qp || !qp[aVal]) return;
      var pts = qp[aVal];
      Object.keys(pts).forEach(function(ing){
        if (formula[ing] !== undefined) formula[ing] += pts[ing];
      });
    }
    addPoints('goal', goal);
    addPoints('training', training);
    addPoints('timing', timing);
    addPoints('feeling', feeling);

    /* 3. Glycerol alleen bij pump */
    if (goal !== 'pump') formula['Glycerol'] = 0;

    /* 4. Intensiteitsmultiplier op functionele ingrediënten */
    var multiplier = INTENSITY_MULTIPLIER[intensity] || 1.0;
    var noMultiply = ['Caféïne', 'Piperine', 'Glycerol'];
    Object.keys(formula).forEach(function(ing){
      if (noMultiply.indexOf(ing) === -1) formula[ing] = formula[ing] * multiplier;
    });

    /* 5. Cap op algeheel maximum */
    Object.keys(formula).forEach(function(ing){
      if (MAX[ing] !== undefined && formula[ing] > MAX[ing]) formula[ing] = MAX[ing];
    });

    /* 5b. Beta Alanine sensitivity-cap — persoonlijk plafond op basis van ervaring */
    var betaAlanineCap = BETA_ALANINE_SENSITIVITY_CAP[betaAlanine];
    if (betaAlanineCap !== undefined && formula['Beta Alanine'] > betaAlanineCap) {
      formula['Beta Alanine'] = betaAlanineCap;
    }

    /* 6. Snap naar dichtstbijzijnde builder-stap */
    Object.keys(formula).forEach(function(ing){
      formula[ing] = snapToStep(ing, formula[ing]);
    });

    /* 7. Caféïne apart instellen, met veiligheidscap voor team/hyrox */
    formula['Caféïne'] = getEffectiveCaffeine(training, caffeine);

    /* 8. Minimale effectieve drempel toepassen */
    var result = {};
    Object.keys(formula).forEach(function(ing){
      if (ing === 'Piperine') {
        result[ing] = 0.005;
        return;
      }
      var minDose = MIN_EFFECTIVE[ing];
      var dose    = formula[ing];
      if (dose > 0 && minDose !== undefined && dose >= minDose) {
        result[ing] = dose;
      } else if (dose > 0 && minDose === undefined) {
        result[ing] = dose;
      }
    });

    return result;
  }

  function buildUrl(formula) {
    var smaak = answers.smaak || 'tropical';
    var ingParts = Object.keys(formula).map(function(name){
      return encodeURIComponent(name) + ':' + formula[name];
    });
    var base = (window.CSTM_BUILDER_URL || '/products/pre-workout-samenstellen').replace(/\/$/, '');
    return base + '?smaak=' + encodeURIComponent(smaak) + '&ingredienten=' + ingParts.join(',');
  }

  function answeredCount() {
    return ANSWER_KEYS.filter(function(k){ return answers[k] !== null; }).length;
  }

  function updateProgress(step) {
    var pct = Math.round((answeredCount() / TOTAL_STEPS) * 100);
    var fill  = document.getElementById('cstmProgressFill');
    var count = document.getElementById('cstmProgressCount');
    if (fill)  fill.style.width = pct + '%';
    if (count) count.textContent = answeredCount() < TOTAL_STEPS
      ? ('Vraag ' + (step + 1) + ' van ' + TOTAL_STEPS)
      : 'Jouw formule';
  }

  function goToStep(idx) {
    document.querySelectorAll('.cstm-quiz-step').forEach(function(s){ s.classList.remove('active'); });
    var r = document.getElementById('cstmResult');
    if (r) r.classList.remove('active');
    var t = document.getElementById('cstmStep' + idx);
    if (t) t.classList.add('active');
    currentStep = idx;
    updateProgress(idx);
  }

  function showResult() {
    var goal        = answers.goal        || 'allround';
    var training    = answers.training    || 'strength';
    var timing      = answers.timing      || 'varies';
    var caffeine    = answers.caffeine    || 'medium';
    var formula     = calculateFormula();

    document.querySelectorAll('.cstm-quiz-step').forEach(function(s){ s.classList.remove('active'); });
    var r = document.getElementById('cstmResult');
    if (r) r.classList.add('active');
    updateProgress(TOTAL_STEPS);

    var nameEl = document.getElementById('cstmResultName');
    var subEl  = document.getElementById('cstmResultSub');
    if (nameEl) nameEl.textContent = RESULT_NAMES[goal];
    if (subEl)  subEl.textContent  = RESULT_SUBS[goal];

    var noteEl   = document.getElementById('cstmTimingNote');
    var noteBody = noteEl ? noteEl.querySelector('.cstm-timing-body') : null;
    var warnings = [];

    var requestedCaffeine = CAFFEINE_MAP[caffeine] || 0;
    var cappedDueToTraining = (CAFFEINE_CAP_TRAININGS.indexOf(training) !== -1 && requestedCaffeine > CAFFEINE_CAP_VALUE);

    if (cappedDueToTraining) {
      var trainingLabel = training === 'team' ? 'teamsport/vechtsport' : 'Hyrox/Crossfit/HIIT';
      warnings.push('Je koos een hogere cafeinedosis, maar voor ' + trainingLabel + ' hebben we dit verlaagd naar 200mg — een veilige dosis voor explosieve, coordinatie-afhankelijke sport zonder risico op overprikkeling of een te hoge hartslag.');
    } else if (timing === 'evening' && caffeine !== 'none' && requestedCaffeine >= 0.3) {
      warnings.push('Je traint \u2019s avonds met een hoge cafeinedosis. Dit kan je slaap beïnvloeden.');
    }
    if (!cappedDueToTraining && caffeine === 'expert') {
      warnings.push('⚠️ Expert-dosering: 400mg cafeine zit op de EFSA daggrens. Gebruik dit alleen als je hier ervaring mee hebt en combineer het niet met andere cafeinebronnen.');
    }

    if (noteEl && noteBody) {
      if (warnings.length > 0) {
        noteEl.style.display = 'flex';
        noteBody.textContent = warnings.join(' ');
      } else {
        noteEl.style.display = 'none';
      }
    }

    var ingredientNames = Object.keys(formula);

    var grid = document.getElementById('cstmIngGrid');
    if (grid) {
      grid.innerHTML = '';
      ingredientNames.forEach(function(name){
        var dose = formula[name];
        var pill = document.createElement('div');
        pill.className = 'cstm-ing-pill';
        var isPiperine = (name === 'Piperine');
        var doseHtml = isPiperine
          ? Math.round(dose * 1000) + '<span class="cstm-ing-unit">mg</span>'
          : dose + '<span class="cstm-ing-unit">g</span>';
        var whyText = INGREDIENT_INFO[name] || '';
        pill.innerHTML = '<span class="cstm-ing-name">' + name + '</span><span class="cstm-ing-dose">' + doseHtml + '</span><span class="cstm-ing-why">' + whyText + '</span>';
        grid.appendChild(pill);
      });
    }

    var compareCountEl = document.getElementById('cstmCompareCount');
    if (compareCountEl) compareCountEl.textContent = ingredientNames.length;

    var url = buildUrl(formula);
    var btn = document.getElementById('cstmCtaBtn');
    if (btn) btn.setAttribute('data-url', url);
  }

  window.cstmGoToBuilder = function() {
    var btn = document.getElementById('cstmCtaBtn');
    var url = btn && btn.getAttribute('data-url');
    if (url) window.location.assign(url);
  };

  function restart() {
    ANSWER_KEYS.forEach(function(k){ answers[k] = null; });
    document.querySelectorAll('.cstm-opt').forEach(function(b){ b.classList.remove('selected'); });
    document.querySelectorAll('.cstm-next-btn').forEach(function(b){ b.classList.remove('visible'); });
    var r = document.getElementById('cstmResult');
    if (r) r.classList.remove('active');
    goToStep(0);
  }

  function initWhyTooltips() {
    document.querySelectorAll('.cstm-why-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var targetId = btn.getAttribute('data-tooltip-target');
        var target = targetId ? document.getElementById(targetId) : null;
        if (!target) return;
        var isOpen = target.classList.contains('open');
        /* Close any other open tooltips first */
        document.querySelectorAll('.cstm-why-tooltip.open').forEach(function(t){
          t.classList.remove('open');
        });
        document.querySelectorAll('.cstm-why-btn[aria-expanded="true"]').forEach(function(b){
          b.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          target.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.cstm-opt').forEach(function(btn){
      btn.addEventListener('click', function(){
        var key = btn.dataset.key;
        var val = btn.dataset.val;
        answers[key] = val;
        btn.closest('.cstm-options').querySelectorAll('.cstm-opt').forEach(function(b){ b.classList.remove('selected'); });
        btn.classList.add('selected');
        updateProgress(currentStep);
        var stepEl = btn.closest('.cstm-quiz-step');
        if (stepEl) {
          var idx = parseInt(stepEl.dataset.step, 10);
          var nb = document.getElementById('cstmNext' + idx);
          if (nb) nb.classList.add('visible');
        }
      });
    });

    for (var i = 0; i < TOTAL_STEPS; i++) {
      (function(idx){
        var btn = document.getElementById('cstmNext' + idx);
        if (!btn) return;
        btn.addEventListener('click', function(){
          if (idx < TOTAL_STEPS - 1) { goToStep(idx + 1); } else { showResult(); }
        });
      })(i);
    }
    for (var j = 1; j < TOTAL_STEPS; j++) {
      (function(idx){
        var btn = document.getElementById('cstmBack' + idx);
        if (!btn) return;
        btn.addEventListener('click', function(){ goToStep(idx - 1); });
      })(j);
    }
    var rb = document.getElementById('cstmRestart');
    if (rb) rb.addEventListener('click', restart);
    initWhyTooltips();
    updateProgress(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
